
import React from "react";
import { Progress } from "@/components/ui/progress";
import { Skeleton } from "@/components/ui/skeleton";

interface SentimentLoadingStateProps {
  progressValue: number;
}

export const SentimentLoadingState: React.FC<SentimentLoadingStateProps> = ({
  progressValue
}) => {
  return (
    <div className="space-y-4">
      <div className="text-center text-primary-light">Analyzing online sentiments...</div>
      <Progress value={progressValue} className="w-full h-2" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Skeleton className="h-48 w-full bg-secondary/50" />
        <Skeleton className="h-48 w-full bg-secondary/50" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Skeleton className="h-36 w-full bg-secondary/50" />
        <Skeleton className="h-36 w-full bg-secondary/50" />
        <Skeleton className="h-36 w-full bg-secondary/50" />
      </div>
    </div>
  );
};
